var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8954_993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3325 13.3332C20.9633 13.3332 26.6652 10.3166 26.6652 7.6193C26.6652 4.92223 20.9632 1.90552 13.3325 1.90552C5.70184 1.90552 0 4.92223 0 7.6193C0 10.3166 5.70171 13.3332 13.3325 13.3332Z",
    fill: "#061A77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3325 36.1895C14.4463 36.1895 15.5183 36.1247 16.538 36.0067C15.6784 34.9021 14.9676 33.6763 14.4351 32.3599C14.0692 32.3722 13.7021 32.3807 13.3324 32.3807C8.97217 32.3807 4.84295 31.5167 1.70571 29.948C1.08799 29.6392 0.51955 29.3073 0 28.9561V30.4757C0 33.1728 5.70171 36.1895 13.3325 36.1895Z",
    fill: "#061A77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 28.5708C13.3718 28.5708 13.4103 28.5702 13.4492 28.5701C13.3711 27.9458 13.3304 27.3099 13.3304 26.6647C13.3304 26.0198 13.371 25.3843 13.4492 24.7605C13.4103 24.7605 13.3716 24.7619 13.3327 24.7619C8.97243 24.7619 4.84333 23.8979 1.70597 22.3293C1.08812 22.0204 0.51955 21.6886 0 21.3374V22.8569C0.000126998 25.5541 5.70184 28.5708 13.3327 28.5708Z",
    fill: "#061A77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 20.9518C13.7106 20.9518 14.0835 20.9442 14.4516 20.9297C15.0429 19.479 15.851 18.1391 16.8363 16.9507C15.6956 17.0765 14.5233 17.1431 13.3327 17.1431C8.97243 17.1431 4.84333 16.2792 1.70597 14.7105C1.08812 14.4015 0.51955 14.0698 0 13.7185V15.2382C0.000126998 17.9354 5.70184 20.9518 13.3327 20.9518Z",
    fill: "#061A77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0478 20.3507C18.2235 21.5899 17.6346 22.9981 17.345 24.5114C17.2112 25.2091 17.1406 25.9288 17.1406 26.6647C17.1406 27.218 17.181 27.7621 17.2573 28.2946C17.4449 29.6028 17.8547 30.8398 18.4473 31.9666C19.0691 33.1491 19.8917 34.2102 20.8699 35.1036C22.9029 36.9605 25.6067 38.0945 28.5705 38.0945C34.8729 38.0945 40.0003 32.9671 40.0003 26.6647C40.0003 20.3622 34.8729 15.2349 28.5705 15.2349C27.9191 15.2349 27.2804 15.2905 26.6584 15.3956C23.49 15.9314 20.7611 17.7753 19.0478 20.3507Z",
    fill: "#061A77"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8954_993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3);
export default __webpack_public_path__ + "static/media/s3.808fb082f85f36b055381c65cfdbea02.svg";
export { ForwardRef as ReactComponent };